function t(e) {
  const [n, o] = (e == null ? void 0 : e.split(".")) ?? [], r = o.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(
    decodeURIComponent(
      window.atob(r).split("").map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      }).join("")
    )
  );
}
export {
  t as decodeToken
};
